let itm = {
  // bcg: require('../bcg_unit.png'),
  bcg2: require('./u10.png'),
  name: 'At the seaside',
  items: [],
};

export default itm;
